<template>
  <AuthLayout class="page-auth">
    <form class="page-auth__form" action="#" @submit.prevent="submit">
      <input
        type="email"
        autocomplete="email"
        :placeholder="$t('pages.auth.email-placeholder')"
        v-model="login"
        required
      />
      <input
        type="password"
        autocomplete="current-password"
        :placeholder="$t('pages.auth.password-placeholder')"
        v-model="password"
        required
      />

      <div class="page-auth__actions">
        <button class="primary large" type="submit">{{ $t('pages.auth.log-in') }}</button>
        <router-link to="/sign-up">
          <button class="gray large" type="button">{{ $t('pages.auth.sign-up') }}</button>
        </router-link>
      </div>

      <div class="page-auth__sub-actions">
        <a :href="`/Manual_for_participants_${$i18n.locale}.pdf`" download class="btn-outline">
          <img src="@/assets/icons/doc.svg" alt="scg">
          <span v-text="$t('pages.auth.download-manual')"/>
        </a>
      </div>


      <div class="error-block" v-if="error">{{ error }}</div>
      <router-link to="/auth?forgot=1" class="page-auth__link">{{ $t('pages.auth.forgot-password') }}</router-link>
    </form>

    <ModalForgotPassword />
    <ModalAccountModeration />
  </AuthLayout>
</template>

<script>
import Checkbox from '@/components/form/Checkbox'
import AuthLayout from '@/components/auth/Authlayout'
import Terms from '@/components/auth/terms'
import ModalForgotPassword from '@/components/modals/ModalForgotPassword'
import { mapMutations } from 'vuex'
import ModalAccountModeration from '@/components/modals/ModalAccountModeration'

export default {
  name: 'Auth',
  components: { ModalAccountModeration, ModalForgotPassword, Terms, AuthLayout, Checkbox },
  data: () => ({
    publicPath: process.env.BASE_URL,
    login: '',
    password: '',
    error: null,
  }),
  computed: {
    modalOpened() {
      return this.$route.query.forgot
    },
  },
  methods: {
    submit() {
      this.error = null
      this.$auth
        .login({
          data: {
            email: this.login,
            password: this.password,
          },
        })
        .catch((e) => {
          let message = e.response?.data?.message || this.$t('pages.auth.errors.server')
          if (message == 'The given data was invalid.') {
            message = this.$t('pages.auth.errors.invalid')
          }

          if (e.response.status == 413) {
            message = this.$t('pages.auth.errors.access')
          }

          this.error = message //e.response?.data?.message || 'Server error';
        })
    },
    ...mapMutations(['openModal', 'closeModal']),
  },
  watch: {
    modalOpened: {
      immediate: true,
      handler(open) {
        if (open) {
          this.openModal('forgot-password')
        } else if (this.$store.state.modal === 'forgot-password') {
          this.closeModal()
        }
      },
    },
  },
}
</script>

<style lang="scss">
.page-auth {
  &__sub-actions {
    margin-top: 20px;
  }
  .btn-outline {
    padding: 12px;
    border: 1px solid $dark;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    outline: none;
    appearance: none;
    text-decoration: none;
    img {
      margin-right: 16px;
    }
    span {
      font-weight: 700;
      font-size: 15px;
      line-height: 20px;
      color: $main;
    }
  }
  .error-block {
    margin-top: 10px;
    color: $primary;
  }

  .message-block {
    margin-top: 10px;
    color: $primary;
  }

  &__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin-top: 42px;

    a {
      text-decoration: none;
    }

    button {
      width: 100%;
    }
  }

  &__link {
    display: inline-block;
    color: $darkGrey;
    font-size: 14px;
    line-height: 157.5%;
    text-decoration: none;
    margin-top: 20px;
    border-bottom: 1px dashed $lightGray;
    transition: all 0.25s;

    &:hover {
      text-decoration: none;
      color: $text;
      border-bottom-color: $darkGrey;
    }
  }
}
</style>
